<template>
    <div>
        <section class="page-title-area d-flex align-items-center bg_cover"
        style="background-image: url('/images/page-title-bg.jpg')">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="page-title-item text-center">
                        <h3 class="title">Email Verification</h3>
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link to="/">Home</router-link>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">verify</li>
                            </ol>
                        </nav>
                    </div> <!-- page title item -->
                </div>
            </div> <!-- row -->
        </div> <!-- row -->
        <div class="page-title-shape">
            <img src="/images/banner-shape.png" alt="shape">
        </div> <!-- page title shape -->
        </section>
    </div>
</template>

<script>
    export default {
        name: "verify",
        data(){
           return{
               errors:{},
               id: this.$route.params.id,
               hash: this.$route.params.hash,
               sig: this.$route.query,
           }
        },
        methods:{
            verify(){
                const q = this.id + "/" + this.hash + "?expires=" + this.sig.expires + "&signature=" + this.sig.signature;
                this.axios.post('/email/verify/' + q).then(()=>{
                    this.$swal({
                        icon: 'success',
                        title: 'Verified!',
                        text: 'Successfully verified',
                    });
                    this.$router.push('/');
                }).catch(error =>{
                    this.errors = error.response.data.errors;
                    this.$swal({
                        icon: 'error',
                        title: 'Error!',
                        text: this.errors.message,
                    });
                    this.$router.push('/');
                })
            }
        },
        created() {
            this.verify();
        }
    }
</script>

<style scoped>

</style>